import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class UserLogin extends Event {
    eventName = 'oms_userLogin';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for User login
     * 
     * @param {string} data.email -  username of the customer
     * @param {string} data.password -  password of the customer
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let email = data.email;
        let password = data.password;

        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.userLogin;
        data.method = 'POST';
        data.canUsePublicAuth = false;
        data.data = {
            client_id: clientId,
            email: email,
            password: password
        };
    
        // send request
        this.sendRequest(data, function (response) {
          if (response) {
            //format response data
            let data = thisObj.formatResponseData(response);

            if (data.success && data.data.access_token) {
                //add data to storage
                let userDetails = new LocalStorage.UserDetails(clientId);
                userDetails.setData(response);
                
                //set auth requesting variable to null - so new access token value can be retriveved from promise
                window.ajaxAuthRequest = null;
            }

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });

    }
}

export default UserLogin;